import * as sterlingparker from './SRMulti.styles.sterlingparker';
import * as fiestabet from './SRMulti.styles.fiestabet';
import * as puntcity from './SRMulti.styles.puntcity';
import * as junglebet from './SRMulti.styles.junglebet';
import * as betroyale from './SRMulti.styles.betroyale';
import * as juicybet from './SRMulti.styles.juicybet';
import * as goldenrush from './SRMulti.styles.goldenrush';
import * as betprofessor from './SRMulti.styles.betprofessor';
import * as volcanobet from './SRMulti.styles.volcanobet';
import * as puntgenie from './SRMulti.styles.puntgenie';
import * as wellbet from './SRMulti.styles.wellbet';
import * as questbet from './SRMulti.styles.questbet';
import * as betgalaxy from './SRMulti.styles.betgalaxy';
import * as vikingbet from './SRMulti.styles.vikingbet';
import * as sugarcastle from './SRMulti.styles.sugarcastle';
import * as oldgill from './SRMulti.styles.oldgill';
import * as buffalobet from './SRMulti.styles.buffalobet';
import * as titanbet from './SRMulti.styles.titanbet';
import * as slambet from './SRMulti.styles.slambet';
import * as gigabet from './SRMulti.styles.gigabet';
import * as betstride from './SRMulti.styles.betstride';
import * as templebet from './SRMulti.styles.templebet';
import * as goldenbet888 from './SRMulti.styles.goldenbet888';
import * as hyperbet from './SRMulti.styles.hyperbet';
import * as bet777 from './SRMulti.styles.bet777';
import * as chromabet from './SRMulti.styles.chromabet';
import * as bet575 from './SRMulti.styles.bet575';
import * as betblast from './SRMulti.styles.betblast';
import * as pyramidbet from './SRMulti.styles.pyramidbet';
import * as magnumbet from './SRMulti.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  fiestabet,
  puntcity,
  junglebet,
  betroyale,
  juicybet,
  goldenrush,
  betprofessor,
  volcanobet,
  puntgenie,
  wellbet,
  questbet,
  betgalaxy,
  vikingbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
